import { Observable } from 'rxjs'
import { AcademicDegree } from '../../../models'

export abstract class MbAcademicDegreesAdapter {

  abstract load(): Observable<AcademicDegree[]>
}
